import React from "react";
import { Cards } from "../Cards/Cards";
import { Videos } from "../Videos/Videos";
import style from "./Container.module.css";

export const Container = () => {
  return (
    <div className={style.container}>
      <Cards></Cards>
      <Videos></Videos>
    </div>
  );
};
